var Backbone = require('backbone');
var _ = require('underscore');

var Base = require('front/components/Base/Base');
var Consultation = require('front/components/Consultation/Consultation');

require('./IndexHero.less');

module.exports = Base.extend({
    template: require('./IndexHero.jinja'),

    el: '.IndexHero',

    initialize: function (options) {
        Base.prototype.initialize.call(this, options);
        var baseBontSize = $('html').css('font-size')
            .slice(0, -2);

        this.$arrow = this.$('.IndexHero-arrow');
        this.$obj2 = this.$('.IndexHero-cityObject--2');
        this.$obj3 = this.$('.IndexHero-cityObject--3');

        // Delta in rems
        this.objDelta2 = 40 / baseBontSize;
        this.objDelta3 = 80 / baseBontSize;

        this.onScroll.__throttled = _.throttle(this.onScroll.bind(this), 20);
        $(window).bind('scroll', this.onScroll.__throttled);
        this.onScroll.__throttled();
    },

    viewsRegistration: function () {
        this.registerView('consultation', new Consultation({
            el: this.$('.Consultation')
        }));
    },

    onScroll: function () {
        var winHeight = $(window).height();
        var scroll = Math.min($(window).scrollTop(), $(window).height());
        var scrollPercentage = scroll / winHeight;

        this.$obj2.css('transform', 'translateX(' + scrollPercentage * this.objDelta2 + 'rem)');
        this.$obj3.css('transform', 'translateX(' + scrollPercentage * this.objDelta3 + 'rem)');
    },

    destroy: function () {
        $(window).unbind('scroll', this.onScroll.__throttled);

        Base.prototype.destroy.call(this);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexHero/IndexHero.js
// module id = 52
// module chunks = 0